import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Fade from 'react-reveal/Fade';

const useStyles = makeStyles(theme => ({
    rowContainer: {
        paddingLeft: "5em",
        paddingRight: "5em",
        overflowX: "hidden",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "1.5em",
            paddingRight: "1.5em",
        }
    },
    itemContainer: {
        maxWidth: "40em",
        marginBottom: "5em"
    }
}))

export default function FullRowMiddle(props) {
    const classes = useStyles();
    const content = props.content;

    const image = props.image;

    let imageW = 300;

    if (props.imageW) {
        imageW = props.imageW;
    }

    const subtitleTxt = () => {
        let x = content.subtitle;
        const lines = x.split("\n");
        return (
            <div>
                {lines.map((line, index) => (
                    <Typography variant="subtitle1" className={classes.subtitle} style={{ textAlign: "justify", maxWidth: image ? "650px" : null, lineHeight: 1.5, marginBottom: "0.4em" }}
                        key={index} >
                        {line}
                    </Typography>))}
            </div>
        )
    }

    return (
        <Grid item container className={classes.rowContainer} direction="row" style={{ marginTop: "0em", marginBottom: "0em" }}>
            <Grid item container direction="column" alignItems="center">

                {image ?
                    <Grid item>
                        <Fade duration={1500}  >
                            <img alt="service" src={image} style={{ width: imageW, maxWidth: "100%" }} />
                        </Fade>
                    </Grid>
                    : null}

                <Grid item className={classes.itemContainer}>
                    <Fade duration={1500}  >
                        <Typography variant="h4" align="center" paragraph>{content.title}</Typography>
                        <div >
                            {subtitleTxt()}
                        </div>
                    </Fade>
                </Grid>
            </Grid>
        </Grid>
    )
}
